module.exports = __webpack_public_path__ + "static/images/challenge.18217f2085693b334ea839ed8c36cbaf.jpg";